import {useContext} from "react";

let currentContext = null

export const useCurrentContext = () => {
    const addCurrentContext = (context) => {
        currentContext = context
    }

    const getCurrentContext = () => {
        return useContext(currentContext);
    }

    return {
        currentContext,
        addCurrentContext,
        getCurrentContext,
    }
}
